import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TrendCardProps {
  trend: string;
  impact: 'High' | 'Medium' | 'Low';
  timeframe: string;
  description: string;
  industries: string[];
}

const TrendCard = ({ trend, impact, timeframe, description, industries }: TrendCardProps) => {
  const impactColors = {
    High: 'bg-error text-white',
    Medium: 'bg-warning text-white',
    Low: 'bg-success text-white'
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-subtle hover:shadow-elevation transition-all duration-300 border border-border">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-display font-semibold text-foreground mb-2">
            {trend}
          </h3>
          <p className="text-sm text-muted-foreground">
            {description}
          </p>
        </div>
        <div className={`px-3 py-1 rounded-full text-xs font-semibold ${impactColors[impact]} ml-4 flex-shrink-0`}>
          {impact} Impact
        </div>
      </div>
      
      <div className="flex items-center space-x-2 text-sm text-muted-foreground mb-4">
        <Icon name="CalendarIcon" size={16} />
        <span>Expected: {timeframe}</span>
      </div>
      
      <div className="pt-4 border-t border-border">
        <div className="text-xs font-semibold text-muted-foreground mb-2">Key Industries:</div>
        <div className="flex flex-wrap gap-2">
          {industries.map((industry, index) => (
            <span key={index} className="px-2 py-1 bg-muted text-foreground text-xs rounded">
              {industry}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrendCard;